import React from 'react';
import { Challenge } from '../types';
import Icon from '../../../components/AppIcon';

interface ChallengesSolutionsProps {
  challenges: Challenge[];
}

const ChallengesSolutions = ({ challenges }: ChallengesSolutionsProps) => {
  return (
    <div className="bg-surface rounded-xl p-6 lg:p-8 elevation-2 mb-8">
      <h2 className="text-2xl font-bold text-text-primary mb-6">Challenges & Solutions</h2>
      
      <div className="space-y-6">
        {challenges.map((challenge) => (
          <div key={challenge.id} className="border border-border rounded-lg p-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Challenge */}
              <div>
                <h3 className="text-lg font-semibold text-text-primary mb-3 flex items-center">
                  <Icon name="AlertTriangle" size={20} className="text-orange-500 mr-2" />
                  {challenge.title}
                </h3>
                <p className="text-text-secondary leading-relaxed mb-4">
                  {challenge.description}
                </p>
              </div>
              
              {/* Solution */}
              <div>
                <h4 className="text-lg font-semibold text-text-primary mb-3 flex items-center">
                  <Icon name="CheckCircle" size={20} className="text-green-500 mr-2" />
                  Solution Approach
                </h4>
                <p className="text-text-secondary leading-relaxed mb-4">
                  {challenge.solution}
                </p>
                
                <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                  <h5 className="text-sm font-semibold text-green-800 mb-2 flex items-center">
                    <Icon name="Target" size={16} className="mr-2" />
                    Impact
                  </h5>
                  <p className="text-sm text-green-700">
                    {challenge.impact}
                  </p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChallengesSolutions;